export default __webpack_public_path__ + "static/media/24-7-icon.55b4f1b7.svg";